import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 bg-[#070B14] text-white/70"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-serif-display text-white text-3xl tracking-[0.3em] uppercase font-light">
            EMIVIA
          </div>
          <p className="mt-6 max-w-md text-sm leading-relaxed font-light">
            Premier UK financial expert. Independent advisory in asset & wealth
            management, luxury investments, and digital assets — built on UK
            precision, transparency, and trust.
          </p>
          <p className="mt-6 text-[11px] uppercase tracking-[0.28em] text-white/40">
            Company No. 13413474 · Incorporated 21 May 2021
          </p>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-5">
            Explore
          </div>
          <ul className="space-y-3 text-sm">
            {[
              { to: "/", label: "Home" },
              { to: "/services", label: "Services" },
              { to: "/borrowers-investors", label: "Borrowers & Investors" },
              { to: "/due-diligence", label: "Due Diligence" },
              { to: "/team", label: "Team" },
              { to: "/contact", label: "Contact" },
            ].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="hover:text-[#D4AF37] transition-colors duration-300"
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s|&/g, "-")}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-5">
            Contact
          </div>
          <ul className="space-y-4 text-sm leading-relaxed">
            <li className="flex gap-3">
              <MapPin size={16} className="mt-0.5 text-[#D4AF37]" strokeWidth={1.5} />
              <span>
                Tall Timbers, 2 Pine Glade,
                <br /> Orpington, England, BR6 8NT
              </span>
            </li>
            <li className="flex gap-3 items-center">
              <Mail size={16} className="text-[#D4AF37]" strokeWidth={1.5} />
              <a
                href="mailto:contact@emivia-limited.com"
                className="hover:text-[#D4AF37] transition-colors"
                data-testid="footer-email"
              >
                contact@emivia-limited.com
              </a>
            </li>
            <li className="flex gap-3 items-center">
              <Phone size={16} className="text-[#D4AF37]" strokeWidth={1.5} />
              <span>United Kingdom</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[11px] uppercase tracking-[0.22em] text-white/40">
          <div>© 2021 EMIVIA Limited · All rights reserved</div>
          <div>CEO · Siri Algeroy</div>
        </div>
      </div>
    </footer>
  );
}
